<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'fleet_reports.daily_battery_usage_report' | translate}}
			</h4>
		</div>
	</div>

	<!-- date filter -->
	<div class="row col-xl-12 mb-4">
		<div class="col-xl-3 col-md-3">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-3 col-md-3">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate" [maxDate]="maxDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<div class="row col-xl-12 mb-4" *ngIf="hasVoltageFilter || hasCapacityFilter || hasVintageFilter || hasManufacturerFilter">
		<div class="col-xl-3 col-md-3" *ngIf="hasVoltageFilter">
			<!-- voltage filter -->
			<label for="warning">{{'fleet_reports.battery_voltage' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryVoltage"
				[items]="batteryVoltagesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="getDailyBatteriesUsageReport()"
			></ng-select>
		</div>
		<div class="col-xl-3 col-md-3" *ngIf="hasCapacityFilter">
			<!-- capacity filter -->
			<label for="warning">{{'devices.battery_capacity' | translate}}</label>
			<ng-select
				[(ngModel)]="selectedBatteryCapacity"
				[items]="batteryCapacitiesOptions"
				name="tags_filter"
				bindValue="value"
				bindLabel="label"
				[clearable]="false"
				(ngModelChange)="getDailyBatteriesUsageReport()"
			></ng-select>
		</div>

		<!-- Manufacturer filter -->
		<div class="col-xl-3 col-md-3" *ngIf="hasManufacturerFilter">
			<label for="battery_manufacturer">{{"devices.battery_manufacturer" | translate}}</label>
			<ng-select
				class="select"
				[(ngModel)]="selectedBatteryManufacturer"
				[items]="batteryManufacturersOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="getDailyBatteriesUsageReport()"
				[placeholder]="'devices.battery_manufacturer' | translate"
			></ng-select>
		</div>

		<!-- Vintage filter -->
		<div class="col-xl-3 col-md-3" *ngIf="hasVintageFilter">
			<label for="batteryVintageSelect">{{"devices.battery_vintage" | translate}}</label>
			<ng-select
				name="batteryVintageSelect"
				id="batteryVintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptionsDropdown"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.battery_vintage' | translate"
				[(ngModel)]="selectedBatteryVintage"
				(change)="batteryVintageSelectionChanged()"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div>
	</div>

	<!-- table -->
	<div class="col-12">
		<sct-custom-table
			[columnsConfig]="columnConfig"
			[data]="tableData"
			[config]="tableConfig"
		></sct-custom-table>
	</div>
</div>
